<template>
    <div class="reg-select">
        <h3 style="text-align: left">Your Order</h3>
        <div class="table-responsive">
            <table class="table">
                <thead>
                <tr>
                    <th style="text-align: left" scope="col">Item</th>
                    <th style="text-align: right" scope="col">Price</th>
                </tr>
                </thead>
                <transition name="component-fade" mode="out-in">
                    <tbody v-if="showCheckout === true">
                    <tr v-if="state.registrantData.regType.id">
                        <td style="text-align: left" scope="col">{{state.registrantData.regType.name}} - {{state.registrantData.regType.type}}</td>
                        <td style="text-align: right" scope="col">${{state.registrantData.regType.price}}
                        </td>
                    </tr>
                    <tr v-if="state.registrantData.btlWorkshop">
                        <td style="text-align: left" scope="col" v-html="state.meetingData.btl_workshop.name + ' - Event RSVP'"></td>
                        <td style="text-align: right" scope="col">${{state.meetingData.btl_workshop.price}}
                        </td>
                    </tr>
                    <tr style="color:cadetblue" v-if="state.registrantData.promoData.clear === 'pass' && showPromo">
                        <td style="text-align: left" scope="col" >Promo: <em>{{state.registrantData.promoCode}}</em></td>
                        <td style="text-align: right" v-if="state.registrantData.promoData.type === 'percentage'" scope="col">(-{{state.registrantData.promoData.referdiscount}}%)
                        <td style="text-align: right" v-else scope="col">(${{state.registrantData.promoData.referdiscount}})
                        </td>
                    </tr>
                    <tr>
                        <th style="text-align: left" scope="col">Total:</th>
                        <th style="text-align: right" scope="col"><h3>${{state.registrantData.total}}</h3></th>
                    </tr>
                    </tbody>

                </transition>
            </table>
        </div>

    </div>
</template>

<script>
    import {mapGetters} from 'vuex'

    export default {
        name: 'Order',
        computed: {
            ...mapGetters({
                state: 'getState',

            }),
            showCheckout: function () {
                if (this.state.registrantData.regType) {
                    return true
                }
            },

          showPromo: function () {
            if (this.state.registrantData.promoCode !== '') {
              return true
            }
          }
        },
    }
</script>

<style scoped>
/* Order summary container */
.reg-select {
  padding: 22px;
  background: linear-gradient(
      135deg,
      #e2f4f2 0%,
      #edf1fa 55%,
      #e6e4f5 100%
  );
  border: 1px solid #cbdce6;
  border-radius: 20px;
  box-shadow: 0 10px 30px rgba(49, 75, 111, 0.10);

  color: #25354a;
  font-family: inherit;
}

.reg-select,
.reg-select * {
  box-sizing: border-box;
}

/* Your Order heading */
.reg-select > h3 {
  margin: 0;
  padding: 20px 24px;

  background: linear-gradient(
      110deg,
      #148f94 0%,
      #427f9e 50%,
      #656dac 100%
  );

  border-bottom: 4px solid #80c9c5;
  border-radius: 13px 13px 0 0;
  color: #ffffff;

  font-family: inherit;
  font-size: 23px;
  font-weight: 800;
  line-height: 1.35;
  letter-spacing: 0.05em;
  text-transform: uppercase;
}

/* Table card */
.reg-select .table-responsive {
  width: 100%;
  margin: 0;
  overflow-x: auto;

  background: #ffffff;
  border: 1px solid #d5deec;
  border-top: 0;
  border-radius: 0 0 13px 13px;
  box-shadow: 0 6px 20px rgba(49, 75, 111, 0.10);

  -webkit-overflow-scrolling: touch;
}

.reg-select .table {
  width: 100%;
  margin: 0;
  border: 0;
  border-collapse: collapse;
  background: #ffffff;

  color: #25354a;
  font-family: inherit;
  font-size: 15px;
}

/* Column headings */
.reg-select .table thead th {
  padding: 15px 24px;
  background: #edf1f8;
  border: 0;
  border-bottom: 2px solid #d9e2ef;

  color: #4c5d82;
  font-size: 11px;
  font-weight: 800;
  line-height: 1.4;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  vertical-align: middle;
}

.reg-select .table thead th:last-child {
  width: 130px;
  background: #e5e8f7;
  color: #505a91;
}

/* Order items */
.reg-select .table tbody td {
  padding: 21px 24px;
  border: 0;
  border-bottom: 1px solid #e1e7ef;

  color: #25354a;
  font-size: 15px;
  line-height: 1.55;
  vertical-align: middle;

  transition: background-color 0.18s ease;
}

.reg-select .table tbody td:first-child {
  background: #ffffff;
  font-weight: 600;
  overflow-wrap: anywhere;
}

.reg-select .table tbody tr:nth-child(even) td:first-child {
  background: #f5f8fc;
}

/* Lavender price column */
.reg-select .table tbody td:last-child {
  width: 130px;
  background: #f0effa;

  color: #535c98;
  font-size: 19px;
  font-weight: 800;
  white-space: nowrap;
}

.reg-select .table tbody tr:nth-child(even) td:last-child {
  background: #e8e7f6;
}

.reg-select .table tbody tr:hover td:first-child {
  background: #e3f3f1;
}

.reg-select .table tbody tr:hover td:last-child {
  background: #dcdff3;
}

/* Promo row — targets the existing inline color */
.reg-select .table tbody tr[style*="cadetblue"] td {
  background: #e2f3ec;
  border-bottom-color: #c6e4d7;
  color: #216b53;
}

.reg-select .table tbody tr[style*="cadetblue"] td:first-child {
  border-left: 4px solid #439c7b;
  padding-left: 20px;
}

.reg-select .table tbody tr[style*="cadetblue"] td:last-child {
  background: #d6ecdf;
  color: #216b53;
  font-size: 17px;
}

.reg-select .table tbody tr[style*="cadetblue"] em {
  display: inline-block;
  margin-left: 4px;
  padding: 3px 9px;

  background: #ffffff;
  border: 1px solid #bddbcd;
  border-radius: 6px;

  color: #216b53;
  font-style: normal;
  font-weight: 800;
  letter-spacing: 0.03em;
}

/* Total row */
.reg-select .table tbody tr:last-child {
  background: linear-gradient(
      110deg,
      #167b83 0%,
      #5866a3 100%
  );
}

.reg-select .table tbody tr:last-child > th {
  padding: 23px 24px;
  background: transparent;
  border: 0;
  border-top: 3px solid #c4d8e5;

  color: #ffffff;
  font-size: 16px;
  font-weight: 800;
  line-height: 1.4;
  vertical-align: middle;
}

.reg-select .table tbody tr:last-child > th:first-child {
  letter-spacing: 0.05em;
  text-transform: uppercase;
}

.reg-select .table tbody tr:last-child h3 {
  margin: 0;
  padding: 0;

  color: #ffffff;
  font-family: inherit;
  font-size: 30px;
  font-weight: 800;
  line-height: 1.2;
  white-space: nowrap;
}

/* Existing fade transition */
.component-fade-enter-active,
.component-fade-leave-active {
  transition: opacity .3s ease;
}

.component-fade-enter,
.component-fade-leave-to {
  opacity: 0;
}

/* Mobile adjustments */
@media (max-width: 600px) {
  .reg-select {
    padding: 12px;
    border-radius: 14px;
  }

  .reg-select > h3 {
    padding: 18px 14px;
    font-size: 20px;
  }

  .reg-select .table thead th {
    padding: 12px 14px;
    font-size: 10px;
  }

  .reg-select .table tbody td {
    padding: 17px 14px;
    font-size: 14px;
  }

  .reg-select .table thead th:last-child,
  .reg-select .table tbody td:last-child {
    width: 100px;
  }

  .reg-select .table tbody td:last-child {
    font-size: 17px;
  }

  .reg-select .table tbody tr[style*="cadetblue"] td:first-child {
    padding-left: 10px;
  }

  .reg-select .table tbody tr[style*="cadetblue"] td:last-child {
    font-size: 15px;
  }

  .reg-select .table tbody tr:last-child > th {
    padding: 20px 14px;
    font-size: 14px;
  }

  .reg-select .table tbody tr:last-child h3 {
    font-size: 25px;
  }
}
.reg-select > h3 {
  font-weight: 300;
  letter-spacing: 0.025em;
}
</style>
